import React from 'react';
import {usePopupEditTasksContext} from './popupEditTasksContext';
import {FormikProvider} from "formik";
import PopupTask from "../PopupTask";


const PopupEditTask = () => {
  const {
    taskID,
    taskTypeID,
    updateData,
    editTask,
    formik
  } = usePopupEditTasksContext();

  return (
    <FormikProvider value={formik}>
      <PopupTask
        taskID={taskID}
        taskTypeID={taskTypeID}
        updateData={updateData}
        formik={formik}
        handleAction={editTask}
      />
    </FormikProvider>
  );
};

export default PopupEditTask;
